import { Skeleton } from '@openedx/paragon';
import { FormSkeletonProps } from './types';

const FormSkeleton = ({ rows = 1 }: FormSkeletonProps) => (
  <div>
    <Skeleton width="25%" className="mb-3" />
    <div className="row">
      <div className="col-lg-6">
        <Skeleton count={rows} className="py-2 mb-3" />
      </div>
      <div className="col-lg-6">
        <Skeleton count={rows} className="py-2 mb-3" />
      </div>
    </div>
  </div>
);

export const CheckoutFormSkeleton = () => (
  <section aria-label="checkout-form" className="col-md-7 pl-md-5">
    {/* Address Form */}
    <FormSkeleton rows={4} />

    <div className="py-3" />

    {/* Stripe Form */}
    <FormSkeleton />

    {/* Place Order Button */}
    <div className="row justify-content-end">
      <div className="col-lg-6 col-md-12">
        <Skeleton className="pb-2 pt-3 mt-4" />
      </div>
    </div>
  </section>
);
